'use client';

import { AddressStep } from './steps/AddressStep';
import { ContactInfoStep } from './steps/ContactInfoStep';
import { SystemIssuesStep } from './steps/SystemIssuesStep';
import { PictureStep } from './steps/PictureStep';
import { SystemAgeStep } from './steps/SystemAgeStep';
import ReplaceVirtuallyFormController from './ReplaceVirtuallyFormController';
import { Suspense } from 'react';
import { HeatSyncHandler } from '../HeatSyncHandler';
import { MessageStep } from './steps/MessageStep';
import { UrgencyStep } from './steps/UrgencyStep';
import { BuyingDecisionStep } from './steps/BuyingDecisionStep';

export interface ReplaceVirtuallyFormProps {
	testId?: string;
}

const ReplaceVirtuallyForm = (props: ReplaceVirtuallyFormProps) => {
	const { testId = 'ReplaceForm' } = props;

	return (
		<div data-testid={testId} className="flex grow flex-col">
			<Suspense>
				<ReplaceVirtuallyFormController>
					<HeatSyncHandler />
					<div className="hvac-container relative">
						{/* If you add a step remember to add the step component here. Order does not matter. */}
						<UrgencyStep />
						<AddressStep />
						<ContactInfoStep />
						<SystemIssuesStep />
						<PictureStep />
						<BuyingDecisionStep />
						<MessageStep />
						<SystemAgeStep />
					</div>
				</ReplaceVirtuallyFormController>
			</Suspense>
		</div>
	);
};

export default ReplaceVirtuallyForm;
